export default "__VITE_ASSET__PZ2geV11__"